import { useI18n } from '@/contexts/i18n-hook';

interface StatusProntaSectionProps {
  pronta: boolean;
  setPronta: (pronta: boolean) => void;
}

export function StatusProntaSection({ pronta, setPronta }: StatusProntaSectionProps) {
  const { t } = useI18n();
  return (
    <div>
      <label className="flex items-center">
        <input
          type="checkbox"
          checked={pronta}
          onChange={(e) => setPronta(e.target.checked)}
          className="mr-2 h-4 w-4"
        />
        <span className="text-sm font-medium text-gray-700">{t('apreciacaoModais.editarParte.statusPronta')}</span>
      </label>
    </div>
  );
}

